module.exports = __webpack_public_path__ + "img/20241112142639-s.1a924ec2.png";